import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative w-full min-h-screen flex items-center justify-center px-4 py-20 overflow-hidden" data-id="element-77">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 gradient-overlay pointer-events-none" data-id="element-78" />

      <motion.div className="max-w-5xl mx-auto text-center relative z-10" initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} data-id="element-79">
        {/* Main headline */}
        <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-[var(--text-light)] mb-6 tracking-tight" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} data-id="element-80">
          MÉTODO JABONES
          <br data-id="element-81" />
          <span className="text-[var(--accent-orange)]" data-id="element-82">ARTESANALES</span>
        </motion.h1>

        {/* Big number */}
        <motion.div className="mb-8" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} data-id="element-83">
          <p className="text-2xl md:text-4xl font-bold text-[var(--accent-orange-light)] mb-2" data-id="element-84">
            27 Recetas Probadas + 12 Fórmulas Profesionales
          </p>
        </motion.div>

        {/* Subheadline */}
        <motion.p className="text-xl md:text-2xl lg:text-3xl text-[var(--text-gray)] mb-12 max-w-3xl mx-auto leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} data-id="element-85">
          Para Crear Jabones Hermosos y Vender Desde Casa
          <br data-id="element-86" />
          <span className="text-[var(--text-light)] font-semibold" data-id="element-87">
            Aunque Empieces Desde Cero
          </span>
        </motion.p>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.8,
        duration: 0.8
      }} data-id="element-88">
          <CTAButton size="large" data-id="element-89">QUIERO EMPEZAR AHORA</CTAButton>
        </motion.div>
      </motion.div>
    </section>;
}